const TopMessageSkeleton = () => {
  return <div className="w-full rounded-xl h-12 skeleton" />;
};

export default TopMessageSkeleton;
